import isDomainExternal from './isDomainExternal';
export default isDomainExternal;
